import React, { useEffect, useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  AccordionItem,
  AccordionHeader,
  Accordion,
  AccordionBody,
} from "reactstrap"
import LoaderComponent from "components/loader"
import Breadcrumb from "components/Common/Breadcrumb"
import { useLazyGetFaqsQuery } from "store/api/investorapi/aboutUs"
import ArrowDown from "../../../assets/images/arrow-down.png"
import ArrowUp from "../../../assets/images/arrow-up.png"
import { useSelector } from "react-redux"

const FaqResources = () => {
  const [getResult, { isFetching }] = useLazyGetFaqsQuery()
  const { userType } = useSelector((state) => state.user)
  const [data, setData] = useState([])
  const [open, setOpen] = useState(0)
  const toggle = (id) => {
    if (open === id) {
      setOpen()
    } else {
      setOpen(id)
    }
  }

  document.title = "FAQs | Prachay"

  const getData = async () => {
    try {
      const { success, data } = await getResult({
        user_type: userType === "INVESTOR" ? "investor" : "wealthPartner",
      }).unwrap()
      if (success) {
        setData(data)
      }
    } catch (error) {}
  }

  useEffect(() => {
    getData()
  }, [userType])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={
              <>
                FAQ<small>s</small>
              </>
            }
          />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  {isFetching ? (
                    <LoaderComponent />
                  ) : (
                    <div className="accordion-wrapper-section">
                      <Accordion open={open} toggle={toggle}>
                        {data.map((item, index) => (
                          <AccordionItem key={index}>
                            <AccordionHeader targetId={index}>
                              {item.question}
                              <div className="">
                                {open === "1" ? (
                                  <img src={ArrowUp} alt="" />
                                ) : (
                                  <img src={ArrowDown} alt="" />
                                )}
                              </div>
                            </AccordionHeader>
                            <AccordionBody accordionId={index}>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.answer,
                                }}
                              />
                            </AccordionBody>
                          </AccordionItem>
                        ))}
                      </Accordion>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default FaqResources
